import { theme } from '@ahmdigital/ui';
import { useEffect } from 'react';
import styled from 'styled-components';

import browser from '../../../../utils/browser';

const { zIndices, colors } = theme;

const OverlayWrapper = styled.div<{ $isShowing: boolean }>`
  background-color: ${colors.black};
  height: 100%;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  transition:
    opacity 250ms linear,
    visibility 0ms linear 250ms;
  visibility: hidden;
  width: 100%;
  z-index: ${zIndices.reactModal};

  ${({ $isShowing }) =>
    $isShowing &&
    `
      display: block;
      opacity: 0.6;
      transition-delay: 0ms;
      visibility: visible;
  `};
`;

type OverlayProps = {
  $isShowing?: boolean;
  onClick: () => void;
};

const Overlay = ({ $isShowing = false, onClick }: OverlayProps) => {
  const windowObj = browser.getWindow();
  useEffect(() => {
    const close = (event: Event) => {
      const keyboardEvent = event as KeyboardEvent;
      if (keyboardEvent.key === 'Escape') {
        onClick();
        (browser.getDocument().activeElement as HTMLElement)?.blur();
      }
    };
    windowObj.addEventListener('keydown', close);
    return () => windowObj.removeEventListener('keydown', close);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onClick]);
  return <OverlayWrapper $isShowing={$isShowing} onClick={onClick} data-testid="overlay" />;
};

export default Overlay;
